import { useEffect, useMemo, useContext } from "react"
import AssessmentContext from "@/components/assessment/AssessmentContext"

const findNextQuestion = (oriQuestionsDetail, targetResponses = "questionId") => {
    const findIndex = oriQuestionsDetail.findIndex((oriQuestionDetail) => {
        const { questionId } = oriQuestionDetail.question
        const status = targetResponses.find((targetResponse) => targetResponse.questionId === questionId)
        return !status
    })
    return findIndex === -1 ? targetResponses.length : findIndex
}

const useFindNextQuestionIndex = (questionsDetail, finalResponseAssessmentContent) => {
    const { setNextQuestionIndex } = useContext(AssessmentContext)
    const findNextQuestionIndex = useMemo(() => {
        if (finalResponseAssessmentContent.length) {
            return findNextQuestion(questionsDetail, finalResponseAssessmentContent) + 1
        }
        return 1
    }, [questionsDetail, finalResponseAssessmentContent])
    useEffect(() => {
        setNextQuestionIndex(findNextQuestionIndex)
    }, [findNextQuestionIndex])
    return findNextQuestionIndex
}

export default useFindNextQuestionIndex
